<template>
  <question-group headline="QuikPoll">
    <quik-poll :model="blast.quikPoll" :respondable="blast.isOpen" />
  </question-group>
</template>

<script>

  import sidebar from "./sidebar.js"

  export default {
    name: 'quikpoll',
    mixins: [sidebar]
  }
</script>



// WEBPACK FOOTER //
// src/components/BlastStudent/sidebar/quikpoll.vue